import { useEffect } from "react";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import FeaturedDrops from "@/components/FeaturedDrops";
import CompleteTheLook from "@/components/CompleteTheLook";
import TShirtsSection from "@/components/TShirtsSection";
import CrownsSection from "@/components/CrownsSection";
import LookbookSection from "@/components/LookbookSection";
import FootwearSection from "@/components/FootwearSection";
import TheList from "@/components/TheList";
import Footer from "@/components/Footer";

export default function HomePage() {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = "smooth";
  }, []);

  return (
    <div className="min-h-screen bg-[#F4EFE6] relative">
      <Navigation />
      <HeroSection />
      <FeaturedDrops />
      <CompleteTheLook />
      <TShirtsSection />
      <CrownsSection />
      <LookbookSection />
      <FootwearSection />
      <TheList />
      <Footer />
    </div>
  );
}
